import { useToastStore } from '../stores/toastStore.js';

export function ToastStack() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4">
      {toasts.map((t) => {
        // Errors stay red; success/info both render as a neutral
        // dark-gray pill so they don't compete with the green accent
        // used by primary actions (HeroCard, "Send" buttons, etc).
        const color =
          t.type === 'error' ? 'bg-neg' : 'bg-surface-2 border border-border-hairline';
        return (
          <div
            key={t.id}
            onClick={() => dismiss(t.id)}
            className={`pointer-events-auto max-w-md cursor-pointer rounded-xl px-4 py-3 text-sm text-white shadow-lg ${color}`}
          >
            {t.message}
          </div>
        );
      })}
    </div>
  );
}
